$(document).ready(function() {

    /* Sponsor bar
	-------------------------------------------------------*/
    // scroll to fixed
    $('#pinSponsorBar').scrollToFixed();


    // init sticky controller
    var sticky_controller = new ScrollMagic.Controller();

    // build Timeline Nav scene			
    new ScrollMagic
        .Scene({
            triggerElement: '#mobile-sponsor-trigger',
            offset: 200,
            triggerHook: 0.5
        })
        .setClassToggle('#mobileNoSponsor', 'sponsor-bar-reveal') // class toggle
        //.addIndicators()
        .addTo(sticky_controller);



    /* init Show Timeline Nav controller
	-------------------------------------------------------*/
    var show_timelineNavController = new ScrollMagic.Controller();

    //build tween
    var show_timelineNav = TweenMax.fromTo('#timelineNavContainer', 0.5, {
        x: -100,
        opacity: 0,
        autoAlpha: 0
    }, {
        x: 0,
        opacity: 1,
        autoAlpha: 1
    });

    // build scene	
    new ScrollMagic
        .Scene({
            triggerElement: '#section2',
            triggerHook: 0,
            offset: -300
        })
        .setTween(show_timelineNav)
        .addTo(show_timelineNavController);



    /* init Hide Timeline Nav controller
	-------------------------------------------------------*/
    var hide_timelineNavController = new ScrollMagic.Controller();

    //build tween
    var hide_timelineNav = TweenMax.to('#timelineNavContainer', 0.5, {
        x: -100,
        opacity: 0,
        autoAlpha: 0
    });

    // build scene	
    new ScrollMagic
        .Scene({
            triggerElement: '#rfaFooter',
            triggerHook: 1,
            offset: 230
        })
        .setTween(hide_timelineNav)
        .addTo(hide_timelineNavController);



    /* init Timeline Nav controller
	-------------------------------------------------------*/
    var timelineNavController = new ScrollMagic.Controller();

    // build tween
    var progressIndicator1 = TweenMax.to('.color_fill-1', 0.5, {
        yPercent: 100
    });
    var progressIndicator2 = TweenMax.to('.color_fill-2', 0.5, {
        yPercent: 100
    });
    var progressIndicator3 = TweenMax.to('.color_fill-3', 0.5, {
        yPercent: 100
    });
    var progressIndicator4 = TweenMax.to('.color_fill-4', 0.5, {
        yPercent: 100
    });
    var progressIndicator5 = TweenMax.to('.color_fill-5', 0.5, {
        yPercent: 100
    });
    var progressIndicator6 = TweenMax.to('.color_fill-6', 0.5, {
        yPercent: 100
    });

    // build Timeline Nav scene			
    new ScrollMagic.Scene({
            triggerElement: '#section2',
            triggerHook: 0,
            duration: '200%',
            offset: 0
        })
        .setTween(progressIndicator1)
        .setClassToggle('#label1', 'label-active') // class toggle
        .addTo(timelineNavController)
        .on('enter', function(e) {
            $('#marker1').addClass('active');
        })
        .on('leave', function(e) {
            $('#marker1').removeClass('active');
        });

    new ScrollMagic.Scene({
            triggerElement: '#section3',
            triggerHook: 0,
            duration: '200%',
            offset: 0
        })
        .setTween(progressIndicator2)
        .setClassToggle('#label2', 'label-active') // class toggle
        .addTo(timelineNavController)
        .on('enter', function(e) {
            $('#marker2').addClass('active');
        })
        .on('leave', function(e) {
            $('#marker2').removeClass('active');
        });

    new ScrollMagic.Scene({
            triggerElement: '#section4',
            triggerHook: 0,
            duration: '250%',
            offset: -1
        })
        .setTween(progressIndicator3)
        .setClassToggle('#label3', 'label-active') // class toggle
        .addTo(timelineNavController)
        .on('enter', function(e) {
            $('#marker3').addClass('active');
        })
        .on('leave', function(e) {
            $('#marker3').removeClass('active');
        });

    new ScrollMagic.Scene({
            triggerElement: '#section5',
            triggerHook: 0,
            duration: '200%',
            offset: 0
        })
        .setTween(progressIndicator4)
        .setClassToggle('#label4', 'label-active') // class toggle
        .addTo(timelineNavController)
        .on('enter', function(e) {
            $('#marker4').addClass('active');
        })
        .on('leave', function(e) {
            $('#marker4').removeClass('active');
        });


    new ScrollMagic.Scene({
            triggerElement: '#section6',
            triggerHook: 0,
            duration: '220%'
        })
        .setTween(progressIndicator5)
        .setClassToggle('#label5', 'label-active') // class toggle
        .addTo(timelineNavController)
        .on('enter', function(e) {
            $('#marker5').addClass('active');
        })
        .on('leave', function(e) {
            $('#marker5').removeClass('active');
        });

    new ScrollMagic.Scene({
            triggerElement: '#section7',
            triggerHook: 0,
            duration: '59.9%'
        })
        .setTween(progressIndicator6)
        .setClassToggle('#label6', 'label-active') // class toggle
        .addTo(timelineNavController)
        .on('enter', function(e) {
            $('#marker6').addClass('active');
        })
        .on('leave', function(e) {
            $('#marker6').removeClass('active');
        });

    // change behaviour of controller to animate scroll instead of jump
    timelineNavController.scrollTo(function(newpos) {
        TweenMax.to(window, 1.3, {
            scrollTo: {
                y: newpos
            },
            ease: Power4.easeInOut
        });
    });

    //  bind scroll to anchor links
    $(document).on("click", "a[href^='#']", function(e) {
        var id = $(this).attr("href");
        if ($(id).length > 0) {
            e.preventDefault();

            // trigger scroll
            timelineNavController.scrollTo(id);

            // if supported by the browser we can even update the URL.
            if (window.history && window.history.pushState) {
                history.pushState("", document.title, id);
            }
        }
    });




    // Media Query
    var windowWidth = $(window).width();
    if (windowWidth === 320) {

        new ScrollMagic.Scene({
                triggerElement: '#section2',
                triggerHook: 0,
                duration: '600%',
                offset: 0
            })
            .setTween(progressIndicator1)
            .setClassToggle('#label1', 'label-active') // class toggle
            .addTo(timelineNavController)

        new ScrollMagic.Scene({
                triggerElement: '#section3',
                triggerHook: 0,
                duration: '600%',
                offset: 0
            })
            .setTween(progressIndicator2)
            .setClassToggle('#label2', 'label-active') // class toggle
            .addTo(timelineNavController)

        new ScrollMagic.Scene({
                triggerElement: '#section4',
                triggerHook: 0,
                duration: '650%',
                offset: -1
            })
            .setTween(progressIndicator3)
            .setClassToggle('#label3', 'label-active') // class toggle
            .addTo(timelineNavController)

        new ScrollMagic.Scene({
                triggerElement: '#section5',
                triggerHook: 0,
                duration: '450%',
                offset: 300
            })
            .setTween(progressIndicator4)
            .setClassToggle('#label4', 'label-active') // class toggle
            .addTo(timelineNavController)

        new ScrollMagic.Scene({
                triggerElement: '#section6',
                triggerHook: 0,
                duration: '650%'
            })
            .setTween(progressIndicator5)
            .setClassToggle('#label5', 'label-active') // class toggle
            .addTo(timelineNavController)

        new ScrollMagic.Scene({
                triggerElement: '#section7',
                triggerHook: 0,
                duration: '150%'
            })
            .setTween(progressIndicator6)
            .setClassToggle('#label6', 'label-active') // class toggle
            .addTo(timelineNavController)

    }
    if (windowWidth === 375) {

        new ScrollMagic.Scene({
                triggerElement: '#section2',
                triggerHook: 0,
                duration: '450%',
                offset: 0
            })
            .setTween(progressIndicator1)
            .setClassToggle('#label1', 'label-active') // class toggle
            .addTo(timelineNavController)

        new ScrollMagic.Scene({
                triggerElement: '#section3',
                triggerHook: 0,
                duration: '450%',
                offset: 0
            })
            .setTween(progressIndicator2)
            .setClassToggle('#label2', 'label-active') // class toggle
            .addTo(timelineNavController)

        new ScrollMagic.Scene({
                triggerElement: '#section4',
                triggerHook: 0,
                duration: '480%',
                offset: -1
            })
            .setTween(progressIndicator3)
            .setClassToggle('#label3', 'label-active') // class toggle
            .addTo(timelineNavController)

        new ScrollMagic.Scene({
                triggerElement: '#section5',
                triggerHook: 0,
                duration: '450%',
                offset: 0
            })
            .setTween(progressIndicator4)
            .setClassToggle('#label4', 'label-active') // class toggle
            .addTo(timelineNavController)

        new ScrollMagic.Scene({
                triggerElement: '#section6',
                triggerHook: 0,
                duration: '480%'
            })
            .setTween(progressIndicator5)
            .setClassToggle('#label5', 'label-active') // class toggle
            .addTo(timelineNavController)

        new ScrollMagic.Scene({
                triggerElement: '#section7',
                triggerHook: 0,
                duration: '100%'
            })
            .setTween(progressIndicator6)
            .setClassToggle('#label6', 'label-active') // class toggle
            .addTo(timelineNavController)

    }
    if (windowWidth === 414) {

        new ScrollMagic.Scene({
                triggerElement: '#section2',
                triggerHook: 0,
                duration: '400%',
                offset: 0
            })
            .setTween(progressIndicator1)
            .setClassToggle('#label1', 'label-active') // class toggle
            .addTo(timelineNavController)

        new ScrollMagic.Scene({
                triggerElement: '#section3',
                triggerHook: 0,
                duration: '400%',
                offset: 0
            })
            .setTween(progressIndicator2)
            .setClassToggle('#label2', 'label-active') // class toggle
            .addTo(timelineNavController)

        new ScrollMagic.Scene({
                triggerElement: '#section4',
                triggerHook: 0,
                duration: '480%',
                offset: -1
            })
            .setTween(progressIndicator3)
            .setClassToggle('#label3', 'label-active') // class toggle
            .addTo(timelineNavController)

        new ScrollMagic.Scene({
                triggerElement: '#section5',
                triggerHook: 0,
                duration: '400%',
                offset: 0
            })
            .setTween(progressIndicator4)
            .setClassToggle('#label4', 'label-active') // class toggle
            .addTo(timelineNavController)

        new ScrollMagic.Scene({
                triggerElement: '#section6',
                triggerHook: 0,
                duration: '480%'
            })
            .setTween(progressIndicator5)
            .setClassToggle('#label5', 'label-active') // class toggle
            .addTo(timelineNavController)

        new ScrollMagic.Scene({
                triggerElement: '#section7',
                triggerHook: 0,
                duration: '75%'
            })
            .setTween(progressIndicator6)
            .setClassToggle('#label6', 'label-active') // class toggle
            .addTo(timelineNavController)

    }
	if (windowWidth === 1024) {
		
		new ScrollMagic.Scene({
                triggerElement: '#section2',
                triggerHook: 0,
                duration: '390%',
                offset: 0
            })
            .setTween(progressIndicator1)
            .setClassToggle('#label1', 'label-active') // class toggle
            .addTo(timelineNavController)

        new ScrollMagic.Scene({
                triggerElement: '#section3',
                triggerHook: 0,
                duration: '350%',
                offset: 0
            })
            .setTween(progressIndicator2)
            .setClassToggle('#label2', 'label-active') // class toggle
            .addTo(timelineNavController)

        new ScrollMagic.Scene({
                triggerElement: '#section4',
                triggerHook: 0,
                duration: '340%',
                offset: -1
            })
            .setTween(progressIndicator3)
            .setClassToggle('#label3', 'label-active') // class toggle
            .addTo(timelineNavController)

        new ScrollMagic.Scene({
                triggerElement: '#section5',
                triggerHook: 0,
                duration: '200%',
                offset: 0
            })
            .setTween(progressIndicator4)
            .setClassToggle('#label4', 'label-active') // class toggle
            .addTo(timelineNavController)

        new ScrollMagic.Scene({
                triggerElement: '#section6',
                triggerHook: 0,
                duration: '290%'
            })
            .setTween(progressIndicator5)
            .setClassToggle('#label5', 'label-active') // class toggle
            .addTo(timelineNavController)

        new ScrollMagic.Scene({
                triggerElement: '#section7',
                triggerHook: 0,
                duration: '75%'
            })
            .setTween(progressIndicator6)
            .setClassToggle('#label6', 'label-active') // class toggle
            .addTo(timelineNavController)
		
	}


    /* Mobile Detect
       -------------------------------------------------------*/
    if (/Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent || navigator.vendor || window.opera)) {
        $('html').addClass('mobile');
    } else {
        $('html').removeClass('mobile');
    }




});